import React, { useState } from 'react';
import Icon from '../AppIcon';

const Header = () => {
  const [currentLanguage, setCurrentLanguage] = useState('fr');

  const toggleLanguage = () => {
    setCurrentLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  const Logo = () => (
    <div className="flex items-center space-x-3">
      <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center shadow-elevation-2">
        <Icon name="Shield" size={24} color="white" strokeWidth={2.5} />
      </div>
      <div className="flex flex-col">
        <span className="text-xl font-semibold text-text-primary font-inter">
          ID Verify
        </span>
        <span className="text-xs text-text-secondary font-inter">
          Vérification d'identité sécurisée
        </span>
      </div>
    </div>
  );

  return (
    <header className="top-0 left-0 right-0 z-50 bg-surface border-b border-border shadow-elevation-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Logo />
          </div>

          {/* Navigation Actions */}
          <div className="flex items-center space-x-4">
            {/* Security Badge */}
            <div className="hidden md:flex items-center space-x-2 px-3 py-2 bg-accent-50 rounded-lg">
              <Icon name="Lock" size={16} color="#059669" />
              <span className="text-xs font-medium text-accent-600 font-inter">
                Sécurisé SSL
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;